import { useEcomConfig } from "./useEcomConfig";

/** Append a cache-busting version to a URL. The logo object keeps the same URL
 *  when its image is replaced, so browsers would otherwise serve the old file.
 *  The version is the config's last successful fetch time - stable within a
 *  session, and fresh again after any refetch (focus / reconnect / reload). */
const withVersion = (url: string, version: string | number | undefined) => {
  if (!version) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}v=${encodeURIComponent(String(version))}`;
};

/**
 * Company name + logo for the app (admin panel + storefront).
 *
 * Both come straight from the public ecom-config (`plntDesc` / `logoUrl`) - no
 * auth, no JWT. `useEcomConfig` keeps that request fresh (refetch on focus /
 * reconnect / stale mount + `setupListeners` in index.tsx), so an edit made
 * elsewhere shows up without a logout + login. No hard-coded fallback: if the
 * config carries no value, nothing renders.
 */
export const useCompanyInfo = () => {
  const { ecomConfig, fulfilledTimeStamp } = useEcomConfig();

  const companyName =
    ecomConfig?.companyName || ecomConfig?.plntDesc || undefined;

  const rawLogoUrl = ecomConfig?.logoUrl || undefined;
  const logoUrl = rawLogoUrl
    ? withVersion(rawLogoUrl, fulfilledTimeStamp)
    : undefined;

  return { companyName, logoUrl };
};
